import { getUserDisplayName } from 'noddi-util';
import { useAuthContext } from 'noddi-web';
import { useState } from 'react';
import {
  organizationBookingAssignee,
  selectedOrganizationBookingUserId,
  type OrganizationBookingAssignee,
  type OrganizationBookingPerson
} from '../utils/organizationBookingAssignee';

/** The summary's pick. Null means the default driver, or the booker when there is no choice. */
export function useOrganizationBookingAssignee(drivers: OrganizationBookingPerson[]): {
  assignee: OrganizationBookingAssignee | null;
  selectedUserId: number | null;
  selectUserId: (userId: number) => void;
} {
  const { userData } = useAuthContext();
  const booker = userData ? { userId: userData.user.id, name: getUserDisplayName(userData.user) } : null;
  const [pickedUserId, setPickedUserId] = useState<number | null>(null);
  const assignee = booker == null ? null : organizationBookingAssignee({ booker, drivers });

  return {
    assignee,
    selectedUserId: selectedOrganizationBookingUserId({
      pickedUserId,
      assignee,
      bookerUserId: booker?.userId ?? null
    }),
    selectUserId: setPickedUserId
  };
}
